export const APP_NAME = {
    SURE_SUPPLY: 'suresupply',
    EASY_START: 'easystart',
    EASY_START_PRO: 'easystartpro',
    EASY_START_MODIFY_CONSENT: 'easystartmodifyconsent',
    WJA: 'wja',
    PSA_AI_CONSENTS: 'PSAAIConsent',
    PSA_GEN_CONSENT: 'PSAGenConsent'
}